import {Link} from "react-router-dom";

export default function ErrorPage() {
    return (
        <div className="flex flex-col text-center justify-center">
            <h1 className="mt-8">Page not found</h1>
            <p>Return to <Link to="/">Home</Link></p>
        </div>
    );
}